import type { FC, PropsWithChildren } from 'react';

import { useAuthenticated } from 'api/authentication/hooks/useAuthenticated';
import { useRefreshAccessToken } from 'api/authentication/hooks/useRefreshAccessToken';
import { AppCircularProgress } from 'components/feedback/AppCircularProgress';

export const Authenticated: FC<PropsWithChildren> = ({ children }) => {
  useRefreshAccessToken();
  const isAuthenticated = useAuthenticated();

  return isAuthenticated ? children : <AppCircularProgress />;
};
